import { endpoints } from '@/services/api/endpoints'

export const isPublicEndpoint = (endpoint: string) => {
  return [endpoints.accountsSignUp].includes(endpoint)
}
